var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocketIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 361,
    height: 361,
    viewBox: "0 0 361 361",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_249_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.257 132.334C229.216 132.14 229.121 131.961 228.983 131.819C228.844 131.676 228.668 131.577 228.475 131.531C215.592 128.38 185.831 139.607 169.691 155.736C166.814 158.589 164.191 161.687 161.851 164.994C156.876 164.544 151.901 164.923 147.665 166.771C135.704 172.031 132.224 185.767 131.252 191.663C131.2 191.986 131.222 192.317 131.318 192.63C131.414 192.943 131.581 193.23 131.805 193.468C132.03 193.707 132.306 193.89 132.613 194.004C132.919 194.118 133.248 194.16 133.574 194.127L152.78 192.019C152.793 193.467 152.88 194.914 153.041 196.354C153.141 197.349 153.585 198.278 154.296 198.981L161.733 206.418C162.437 207.13 163.367 207.574 164.363 207.674C165.794 207.833 167.232 207.92 168.672 207.934L166.566 227.124C166.533 227.449 166.575 227.777 166.69 228.084C166.804 228.39 166.987 228.666 167.225 228.89C167.463 229.114 167.749 229.281 168.062 229.377C168.374 229.472 168.705 229.495 169.027 229.443C174.926 228.495 188.691 225.015 193.919 213.056C195.767 208.815 196.146 203.866 195.72 198.915C199.037 196.577 202.144 193.954 205.004 191.076C221.204 174.966 232.36 145.859 229.257 132.334ZM190.605 170.206C189.19 168.792 188.226 166.989 187.836 165.027C187.445 163.065 187.646 161.03 188.411 159.182C189.177 157.333 190.473 155.753 192.137 154.642C193.801 153.53 195.757 152.937 197.757 152.937C199.758 152.937 201.714 153.53 203.378 154.642C205.041 155.753 206.338 157.333 207.104 159.182C207.869 161.03 208.069 163.065 207.679 165.027C207.288 166.989 206.325 168.792 204.91 170.206C203.971 171.147 202.856 171.893 201.629 172.402C200.402 172.911 199.086 173.173 197.757 173.173C196.429 173.173 195.113 172.911 193.886 172.402C192.658 171.893 191.544 171.147 190.605 170.206Z",
    fill: "url(#paint0_linear_249_595)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_249_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.826 202.98C143.464 203.27 141.267 204.341 139.584 206.022C135.409 210.211 135.014 225.724 135.014 225.724C135.014 225.724 150.536 225.328 154.713 221.149C156.401 219.468 157.473 217.267 157.757 214.902",
    fill: "url(#paint1_linear_249_595)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_249_595",
    x: 0.223526,
    y: -0.00108337,
    width: 360.553,
    height: 360.472,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.328677 0 0 0 0 0.122116 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_249_595",
    x: 4.01259,
    y: 71.9794,
    width: 284.746,
    height: 284.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 65.5005
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.328677 0 0 0 0 0.122116 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_249_595"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_249_595",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_249_595",
    x1: 184.974,
    y1: 165.147,
    x2: 120.714,
    y2: 166.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF541F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD1F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_249_595",
    x1: 147.418,
    y1: 210.867,
    x2: 132.588,
    y2: 211.245,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF541F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFAD1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketIcon);
export default __webpack_public_path__ + "static/media/RocketIcon.a4cb7397e999c3a93dc0c15a9fa4a0ae.svg";
export { ForwardRef as ReactComponent };